<template>
  <collapse-text text="Cookies used by Timbre">
    <ul class="cookies-list clean-list mt-2">
      <li v-for="cookie_info in cookie_list" :key="cookie_info.name">
        <strong>{{ cookie_info.name }}:</strong> {{ cookie_info.desc }}
      </li>
    </ul>
  </collapse-text>
</template>

<script>
import CollapseText from 'VueComponents/CollapseText';

export default {
  components: {
    CollapseText,
  },
  data: () => ({
    cookie_list: [
      {
        name: `System Cookies`,
        desc: `Used in order to maintain your session and allow you to use the site.`,
      },
      {
        name: `Preference Cookies`,
        desc: `Used in order to improve your user experience i.e. permanently dismiss a notification, store your table column preferences etc.`,
      },
      {
        name: `Google Analytics Cookies`,
        desc: `Used to provide us with usage analytics, device insights etc.`,
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.cookies-list {
  max-width: 35vw;
}
</style>
